import * as api from '../../api'
import * as orderActions from '../actions/order'
import * as orderSelectors from '../../selectors/order'

export const getOrderSummary = () => (dispatch, getState) => {
  const state = getState()
  const selectedDeliveryDay = orderSelectors.getSelectedDeliveryDay(state)
  const products = orderSelectors.getProductsIds(state)
  const zipcode = orderSelectors.getZipcode(state).value

  const date = selectedDeliveryDay && selectedDeliveryDay.value

  dispatch(orderActions.getOrderSummary())

  return api
    .getOrderSummary({ date, products, zipcode })
    .then(res => {
      if (res.errors) {
        dispatch(orderActions.getOrderSummaryFail(res.errors))
        return false
      }
      dispatch(orderActions.getOrderSummarySuccess(res.data.orderSummary))
      return true
    })
    .catch(err => {
      dispatch(orderActions.getOrderSummaryFail(err))
      return false
    })
}

export const applyCoupon = () => (dispatch, getState) => {
  const state = getState()
  const code = orderSelectors.getCoupon(state)
  const orderSummary = orderSelectors.getOrderSummary(state)

  dispatch(orderActions.applyCoupon())

  const coupon = {
    code,
    quote: orderSummary ? `${orderSummary.id}` : null
  }

  return api
    .applyCoupon(coupon)
    .then(res => {
      if (res.errors) {
        dispatch(orderActions.applyCouponFail(res.errors))
        return { success: false, error: res.errors[0].message }
      }
      dispatch(orderActions.applyCouponSuccess(res.data.applyCoupon))
      return { success: true }
    })
    .catch(error => {
      dispatch(orderActions.applyCouponFail(error))
      return { success: false, error: error.graphQLErrors[0].message }
    })
}

export const createOrder = () => (dispatch, getState) => {
  const state = getState()
  const selectedDeliveryDay = orderSelectors.getSelectedDeliveryDay(state)
  const orderSummary = orderSelectors.getOrderSummary(state)
  const { start, end } = orderSelectors.getSelectedDeliveryTime(state)

  const order = {
    start,
    end,
    tip: orderSelectors.getTip(state),
    cardId: orderSelectors.getSelectedCard(state).id,
    quoteId: orderSummary ? orderSummary.id : null,
    addressId: orderSelectors.getSelectedAddress(state).id,
    deliveryDate: selectedDeliveryDay && selectedDeliveryDay.value,
    products: orderSelectors.getProductsIds(state),
    comments: orderSelectors.getOrderComments(state)
  }

  dispatch(orderActions.createOrder())
  return api
    .createOrder(order)
    .then(res => {
      if (res.errors) {
        dispatch(orderActions.createOrderFail(res.errors))
        return { success: false, error: res.errors[0].message }
      }
      dispatch(orderActions.createOrderSuccess(res.data.createOrder))
      return { success: true }
    })
    .catch(error => {
      dispatch(orderActions.createOrderFail(error))
      return { success: false, error: error.graphQLErrors[0].message }
    })
}



// WEBPACK FOOTER //
// ./src/store/effects/order.js